'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = require('react');
var React = _interopRequireWildcard(_react);
var _propTypes = require('prop-types');
var PropTypes = _interopRequireWildcard(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _lodash = require('lodash');
var _omit = require('omit.js');
var _omit2 = _interopRequireDefault(_omit);
var _browser = require('../_util/browser');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

// modified by njq.niu@hand-china.com
function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value;
}
// modified by njq.niu@hand-china.com
function isChrome() {
  if (typeof window !== 'undefined') {
    var win = window;
    return !!win.chrome; // && !!win.chrome.webstore;
  }

  return false;
}
// modified by yang.wang06@hand-china.com
function isNeedTriggerAfterComposition() {
  return isChrome() || (0, _browser.getIeVersion)() === 11;
}
// modified by njq.niu@hand-china.com
function upperCaseString(value) {
  if ((0, _lodash.isString)(value)) {
    return value.toUpperCase();
  }
  return undefined;
}
// modified by njq.niu@hand-china.com
function lowerCaseString(value) {
  if ((0, _lodash.isString)(value)) {
    return value.toLowerCase();
  }
  return undefined;
}
/**
 * 判断是否全角
 * modified by njq.niu@hand-china.com
 */
function isDbc(s) {
  var dbc = false;
  if ((0, _lodash.isString)(s)) {
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c > 65248 || c === 12288) {
        dbc = true;
        break;
      }
    }
  }
  return dbc;
}
/**
 * 全角转半角
 * modified by njq.niu@hand-china.com
 */
function dbcToSbc(str) {
  var result = [];
  if ((0, _lodash.isString)(str)) {
    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i); // 获取当前字符的unicode编码
      if (code >= 65281 && code <= 65373) {
        // 在这个unicode编码范围中的是所有的英文字母已及各种字符
        result.push(String.fromCharCode(code - 65248)); // 把全角字符的unicode编码转换为对应半角字符的unicode码
      } else if (code === 12288) {
        // 空格
        result.push(' ');
      } else {
        result.push(str.charAt(i));
      }
    }
  }
  return result.join('');
}
var Input = function (_React$Component) {
  (0, _inherits3['default'])(Input, _React$Component);
  function Input() {
    (0, _classCallCheck3['default'])(this, Input);

    // modified by njq.niu@hand-china.com
    var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
    _this.state = {
      type: 'text',
      showPassword: false
    };
    _this.isOnComposition = false;
    // modified by njq.niu@hand-china.com
    _this.handleShowPassword = function () {
      _this.setState({
        type: 'text',
        showPassword: true
      });
    };
    // modified by njq.niu@hand-china.com
    _this.handleHidePassword = function () {
      _this.setState({
        type: 'password',
        showPassword: false
      });
    };
    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
        onPressEnter = _this$props.onPressEnter,
        onKeyDown = _this$props.onKeyDown;
      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }
      if (onKeyDown) {
        onKeyDown(e);
      }
    };
    _this.saveInput = function (node) {
      _this.input = node;
    };
    // modified by njq.niu@hand-china.com
    _this.handleComposition = function (e) {
      if (e.type === 'compositionend') {
        // composition is end
        _this.isOnComposition = false;
        if (isNeedTriggerAfterComposition()) {
          _this.handleChange(e);
        }
      } else {
        // in composition
        _this.isOnComposition = true;
      }
    };
    // modified by njq.niu@hand-china.com
    _this.handleBlur = function (e) {
      var value = e.target.value;
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        trim = _this$props2.trim,
        trimAll = _this$props2.trimAll,
        onBlur = _this$props2.onBlur;
      var trimValue = value;
      if (trim && (0, _lodash.isString)(value)) {
        trimValue = value.trim();
      }
      if (trimAll && (0, _lodash.isString)(value)) {
        trimValue = value.replace(/\s/g, '');
      }
      if (trimValue !== value) {
        _this.input.value = trimValue;
        if (onChange && (0, _lodash.isFunction)(onChange)) {
          e.target.value = trimValue;
          onChange(e);
        }
      }
      if (onBlur && (0, _lodash.isFunction)(onBlur)) {
        onBlur(e);
      }
    };
    // modified by njq.niu@hand-china.com
    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      if (!_this.isOnComposition) {
        // 在 onChange 时记录光标的位置
        if (_this.input) {
          _this.inputSelection = {
            start: _this.input.selectionStart,
            end: _this.input.selectionEnd
          };
        }
        var transformValue = _this.transformValue(e.target.value);
        if (transformValue !== e.target.value) {
          e.target.value = _this.transformValue(e.target.value);
          if (_this.inputSelection && (_this.inputSelection.start || _this.inputSelection.end)) {
            e.target.setSelectionRange(_this.inputSelection.start, _this.inputSelection.end);
            _this.inputSelection = null;
          }
        }
      }
      if (onChange && (0, _lodash.isFunction)(onChange)) {
        onChange(e);
      }
    };
    return _this;
  }
  // modified by njq.niu@hand-china.com

  (0, _createClass3['default'])(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        type: this.props.type
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var inputSelection = this.inputSelection;
      var value = prevProps.value;
      if (inputSelection && value && !this.isOnComposition) {
        // 在 didUpdate 时根据情况恢复光标的位置
        // 如果光标的位置小于值的长度，那么可以判定属于中间编辑的情况
        // 此时恢复光标的位置
        // 当如果不是 onComposiotionend 触发的事件时不用修改位置
        if (inputSelection.start && this.transformValue(value).length && inputSelection.start < this.transformValue(value).length) {
          var input = this.input;
          input.selectionStart = inputSelection.start;
          input.selectionEnd = inputSelection.end;
          this.inputSelection = null;
        }
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: 'getInputClassName',
    value: function getInputClassName() {
      var _classNames;
      var _props = this.props,
        prefixCls = _props.prefixCls,
        size = _props.size,
        disabled = _props.disabled,
        typeCase = _props.typeCase;
      return (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-upper', typeCase === 'upper'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lower', typeCase === 'lower'), _classNames));
    }
  }, {
    key: 'renderLabeledInput',
    value: function renderLabeledInput(children) {
      var _classNames3;
      var props = this.props;
      // Not wrap when there is not addons
      if (!props.addonBefore && !props.addonAfter) {
        return children;
      }
      var wrapperClassName = props.prefixCls + '-group';
      var addonClassName = wrapperClassName + '-addon';
      var addonBefore = props.addonBefore ? React.createElement('span', {
        className: addonClassName
      }, props.addonBefore) : null;
      var addonAfter = props.addonAfter ? React.createElement('span', {
        className: addonClassName
      }, props.addonAfter) : null;
      var className = (0, _classnames2['default'])(props.prefixCls + '-wrapper', (0, _defineProperty3['default'])({}, wrapperClassName, addonBefore || addonAfter));
      var groupClassName = (0, _classnames2['default'])(props.prefixCls + '-group-wrapper', (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-lg', props.size === 'large'), _classNames3));
      // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper
      if (addonBefore || addonAfter) {
        return React.createElement('span', {
          className: groupClassName,
          style: props.style
        }, React.createElement('span', {
          className: className
        }, addonBefore, React.cloneElement(children, {
          style: null
        }), addonAfter));
      }
      return React.createElement('span', {
        className: className
      }, addonBefore, children, addonAfter);
    }
  }, {
    key: 'renderLabeledIcon',
    value: function renderLabeledIcon(children) {
      var _classNames4;

      // modified by njq.niu@hand-china.com
      var props = (0, _extends3['default'])({}, this.props);
      var showPassword = this.state.showPassword;
      var classString = (0, _classnames2['default'])('anticon', {
        'anticon-eye': !showPassword,
        'anticon-eye-o': showPassword
      });
      var eyePro = {
        onMouseDown: this.handleShowPassword,
        onMouseLeave: this.handleHidePassword,
        onMouseUp: this.handleHidePassword
      };
      if (this.props.type === 'password') {
        props = (0, _extends3['default'])((0, _extends3['default'])({}, props), {
          suffix: React.createElement('i', (0, _extends3['default'])({
            className: classString,
            style: {
              cursor: 'pointer'
            },
            key: 'showPasswordIcon'
          }, eyePro))
        });
      }
      if (!('prefix' in props || 'suffix' in props)) {
        return children;
      }
      var prefix = props.prefix ? React.createElement('span', {
        className: props.prefixCls + '-prefix'
      }, props.prefix) : null;
      var suffix = props.suffix ? React.createElement('span', {
        className: props.prefixCls + '-suffix'
      }, props.suffix) : null;
      var affixWrapperCls = (0, _classnames2['default'])(props.className, props.prefixCls + '-affix-wrapper', (_classNames4 = {}, (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-lg', props.size === 'large'), _classNames4));
      return React.createElement('span', {
        className: affixWrapperCls,
        style: props.style
      }, prefix, React.cloneElement(children, {
        style: null,
        className: this.getInputClassName()
      }), suffix);
    }
    // modified by njq.niu@hand-china.com
  }, {
    key: 'transformValue',
    value: function transformValue(v) {
      var _props2 = this.props,
        typeCase = _props2.typeCase,
        _props2$dbc2sbc = _props2.dbc2sbc,
        dbc2sbc = _props2$dbc2sbc === undefined ? true : _props2$dbc2sbc,
        inputChinese = _props2.inputChinese;
      var value = v;
      if (typeCase === 'upper') {
        value = upperCaseString(v);
      } else if (typeCase === 'lower') {
        value = lowerCaseString(v);
      }
      if (dbc2sbc && isDbc(v)) {
        value = dbcToSbc(v);
      }
      if (!inputChinese && (0, _lodash.isString)(value)) {
        value = value.replace(/[\u4e00-\u9fa5]/g, '');
      }
      return value;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props3 = this.props,
        value = _props3.value,
        className = _props3.className;
      var type = this.state.type;
      // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'form', 'onChange', 'dbc2sbc', 'typeCase', 'trim', 'trimAll', 'inputChinese', 'type']);
      if ('value' in this.props) {
        otherProps.value = fixControlledValue(value);
        // Input elements must be either controlled or uncontrolled,
        // specify either the value prop, or the defaultValue prop, but not both.
        delete otherProps.defaultValue;
      }
      return this.renderLabeledIcon(React.createElement('input', (0, _extends3['default'])({}, otherProps, {
        type: type // modified by njq.niu@hand-china.com
        ,
        className: (0, _classnames2['default'])(this.getInputClassName(), className),
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur // modified by njq.niu@hand-china.com
        ,
        onChange: this.handleChange // modified by njq.niu@hand-china.com
        ,
        onCompositionStart: this.handleComposition // modified by njq.niu@hand-china.com
        ,
        onCompositionUpdate: this.handleComposition // modified by njq.niu@hand-china.com
        ,
        onCompositionEnd: this.handleComposition // modified by njq.niu@hand-china.com
        ,
        ref: this.saveInput
      })));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderLabeledInput(this.renderInput());
    }
  }]);
  return Input;
}(React.Component);
exports['default'] = Input;
Input.defaultProps = {
  prefixCls: 'ant-input',
  type: 'text',
  disabled: false,
  dbc2sbc: true,
  trim: true,
  trimAll: false,
  inputChinese: true
};
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  dbc2sbc: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefixCls: PropTypes.string,
  autosize: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node
};
module.exports = exports['default'];